import styled from "styled-components";

interface ICarouselContainer {
  zIndex: any;
  cardType: any;
  marginBottom: any;
  blackAndWhite: any;
}

export const CarouselContainer = styled.div<ICarouselContainer>`
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  z-index: ${(props) => (props.zIndex === null ? 1 : props.zIndex + 5)};

  margin-bottom: ${(props) =>
    props.marginBottom ? 16 + props.marginBottom : 32}px;

  .slides-grid-container {
    width: 100%;
    display: flex;
    position: relative;
    align-items: center;

    :hover {
      .fake-nav svg {
        visibility: visible;
      }
    }

    .fake-nav {
      top: 0;
      bottom: 0;
      width: 56px;
      display: flex;
      position: absolute;
      margin-right: 12px;
      align-items: center;
      cursor: not-allowed;
      justify-content: center;
      border-radius: 0 6px 6px 0;
      background: transparent;
      transition: all 100ms ease-in-out;

      :hover {
        background: ${({ theme }) =>
          theme.mode === "dark" ? "#181818" : "#ddd"};
      }

      svg {
        filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.3));
        visibility: hidden;
      }
    }
  }

  .slides-grid {
    width: 100%;
    display: grid;
    grid-gap: 8px;
    padding: 0 4.25rem;
    grid-template-columns: repeat(5, 1fr);
  }

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    h3 {
      font-size: 1.25rem;
      margin: 0 15px 0 4rem;
      color: ${({ theme }) => theme.colors.textColor};

      @media (max-width: 990px) {
        margin: 0 15px 5px 7.5px;
      }
    }

    span {
      color: #888;
      font-size: 0.938rem;
      margin-top: 4px;
      font-weight: 300;
    }
  }

  .alice-carousel__wrapper {
    overflow: visible;
    padding: 0 60px !important;
  }

  .alice-carousel :hover {
    .alice-carousel__prev-btn svg,
    .alice-carousel__next-btn svg {
      visibility: visible;
    }
  }

  .alice-carousel__stage-item {
    padding: 0 4px;
  }

  .alice-carousel__prev-btn,
  .alice-carousel__next-btn {
    top: 0%;
    padding: 0;
    width: 54px;
    display: flex;
    position: absolute;
    align-items: center;
    height: 100%;

    :hover svg {
      opacity: 0.8;
    }
  }

  .alice-carousel__prev-btn svg,
  .alice-carousel__next-btn svg {
    color: ${({ theme, blackAndWhite }) =>
      blackAndWhite &&
      (theme.mode === "dark" ? "#fff !important" : "#0F0F0F !important")};
    visibility: hidden;
    opacity: 0.5;
    transition: opacity 100ms ease-in-out;
  }

  .alice-carousel__prev-btn {
    left: 0;
    text-align: center;
    transition: opacity 100ms ease-in-out;
  }

  .alice-carousel__next-btn {
    right: 0;
    text-align: center;
    transition: opacity 100ms ease-in-out;
  }

  @media screen and (max-width: 1600px) {
    .slides-grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media screen and (max-width: 1366px) {
    .slides-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media screen and (max-width: 1024px) {
    .slides-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media screen and (max-width: 768px) {
    .slides-grid {
      grid-template-columns: 1fr;
    }

    .alice-carousel__wrapper {
      margin-bottom: 40px;
    }
  }

  @media screen and (max-width: 475px) {
    .section-header {
      flex-wrap: wrap;
      margin: 0 0 5px 0;
    }

    .slides-grid {
      padding: 0 5px;
    }

    .alice-carousel__wrapper {
      padding: 0 !important;
    }

    .alice-carousel__prev-btn,
    .alice-carousel__next-btn {
      display: none;
    }
  }
`;
